// Turns Geography "Metadata" tab filters into a Data Table link.
// The Data Table reads ?geo=<json> once on load (see parseInitState in views/Datatable.js).

export const DATATABLE_PATH = '/pass/datatable';

/**
 * @param f              applied map filters (EMPTY_FILTERS shape in MetadataGeography)
 * @param countryLabels  optional — restrict to these Metadata country labels
 *                       (a clicked map country); replaces the Country filter
 */
export function geoFiltersToDatatableUrl(f, countryLabels) {
  const filters = {
    metaName:      f.names,
    metaOrganism:  f.organisms,
    metaIsoSource: f.isoSources,
    metaCountry:   countryLabels?.length ? countryLabels : f.countries,
    metaContinent: f.continents,
    metaCenter:    f.centers,
    metaPlatform:  f.platforms,
    collFrom:      f.collFrom,
    collTo:        f.collTo,
    sraFileFrom:   f.sraFrom,
    sraFileTo:     f.sraTo,
    runStartFrom:  f.runStartFrom,
    runStartTo:    f.runStartTo,
    runEndFrom:    f.runEndFrom,
    runEndTo:      f.runEndTo,
    bt2HitsMin:    f.minReadHits ? String(f.minReadHits) : '',
    blastNHitsMin: f.minRegionHits ? String(f.minRegionHits) : '',
    blastNRegions: f.regions,
  };
  // Drop empty values to keep the URL short.
  Object.keys(filters).forEach(k => {
    const v = filters[k];
    if (v === '' || v == null || (Array.isArray(v) && v.length === 0)) delete filters[k];
  });
  const geo = {
    filters,
    readHitsOnly:   Boolean(f.readHits),
    regionHitsOnly: Boolean(f.regionHits),
    hideIncomplete: Boolean(f.hideIncomplete),
  };
  return `${DATATABLE_PATH}?geo=${encodeURIComponent(JSON.stringify(geo))}`;
}
